// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PriceParity40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PriceParity40: FC<PriceParity40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M3.333 35v-2.778h15.278V12.57a4.99 4.99 0 0 1-1.916-1.209 4.99 4.99 0 0 1-1.209-1.916h-6.18l5.139 12.277c-.019 1.297-.565 2.399-1.64 3.306-1.073.907-2.379 1.36-3.916 1.36s-2.843-.453-3.917-1.36c-1.074-.907-1.62-2.01-1.639-3.306l5.14-12.277H5V6.667h10.486a4.968 4.968 0 0 1 1.736-2.396A4.482 4.482 0 0 1 20 3.333c1.028 0 1.954.313 2.778.938a4.967 4.967 0 0 1 1.736 2.396H35v2.778h-3.472l5.139 12.277c-.019 1.297-.565 2.399-1.64 3.306-1.073.907-2.379 1.36-3.916 1.36s-2.843-.453-3.916-1.36c-1.075-.907-1.621-2.01-1.64-3.306l5.14-12.277h-6.181a4.99 4.99 0 0 1-1.209 1.916 4.99 4.99 0 0 1-1.916 1.209v19.652h15.278V35H3.333Zm24.653-13.333h6.25l-3.125-7.528-3.125 7.528Zm-22.222 0h6.25l-3.125-7.528-3.125 7.528ZM20 10c.546 0 1.007-.192 1.382-.576.375-.385.563-.84.563-1.368 0-.547-.188-1.007-.563-1.382A1.879 1.879 0 0 0 20 6.11c-.528 0-.984.188-1.368.563a1.855 1.855 0 0 0-.577 1.382c0 .527.193.983.577 1.368.384.384.84.576 1.368.576Z" />
        </svg>
    );
};

export default PriceParity40;
